import React, { useState } from 'react';
import { Container, Popover, Button, Box, TextField, } from '@material-ui/core'

import { DateUtils } from 'react-frontend-utils' 
import Autocomplete from '@material-ui/lab/Autocomplete';

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 20,
        marginTop: 10,
        marginBottom: 10
    },
};



export function MonthYearPicker(props) {

    const currentYear = (new Date()).getFullYear();
    const currentMonth = (new Date()).getMonth() + 1;  //getMonth() is zero based

    const [startMonth, setStartMonth] = useState(props.startMonth ? props.startMonth : currentMonth);
    const [endMonth, setEndMonth] = useState(props.endMonth ? props.endMonth : currentMonth);
    const [year, setYear] = useState(props.year ? props.year : currentYear);

    let maxWidth = window.innerWidth * 0.5;  //half the window, up to 500
    if (maxWidth > 500)
        maxWidth = 500;

   

    const onSelect = () => {
        if (startMonth > endMonth)
            return;
        
        props.okCallback(startMonth, endMonth, year);
    }

    const monthArray = DateUtils.monthNames.map((name, index) => {
        return { label: name, value: index + 1 };
    });

    const yearArray = Array.from({ length: currentYear - props.minYear + 1 }, (_, i) => {
                        const y = props.minYear + i;
                        return { label: y, value: y };
                    })

    const initialStartMonth = monthArray.find(m => m.value === startMonth) || monthArray[0];
    const initialEndMonth = monthArray.find(m => m.value === endMonth) || monthArray[0];
    const initialYear = yearArray.find(y => y.value === year) || yearArray[yearArray.length - 1];

    const invalid = startMonth > endMonth;

    return (
        <Popover open={props.isOpen} 
            anchorReference="anchorPosition"
            anchorPosition={{left: window.innerWidth/2, top: window.innerHeight/2}}
            transformOrigin={{vertical: 'center', horizontal: 'center'}}  >
            
            <Box style={{margin: 20, width: maxWidth}}>
                
                <div style={{display: 'flex', textAlign: 'center', fontWeight: 'bold', marginBottom: 20}}>{props.title}</div>
               
                <div style={{display: 'flex', justifyContent: 'center', alignItemes: 'center', gap: 20, marginTop: 20}}>
                    <Autocomplete size='small'
                        id="month-select"
                        getOptionLabel={(option) => option.label}
                        options={monthArray}
                        defaultValue={initialStartMonth}
                        onChange={(event, newValue) => { setStartMonth(newValue.value) }}
                        getOptionSelected={(option, value) => option.value === value.value}
                        style={{ width: 150 }}
                        blurOnSelect
                        renderInput={(params) => <TextField {...params} label="Start Month" variant="outlined" InputLabelProps={{ shrink: true }} />}
                    />

                    <Autocomplete
                        size='small'
                        id="end-month-select"
                        getOptionLabel={(option) => option.label}
                        options={monthArray}
                        defaultValue={initialEndMonth}
                        onChange={(event, newValue) => { setEndMonth(newValue.value); }}
                        getOptionSelected={(option, value) => option.value === value.value}
                        style={{ width: 150 }}
                        blurOnSelect
                        renderInput={(params) => <TextField {...params} label="End Month" variant="outlined" InputLabelProps={{ shrink: true }} />}
                    />
                </div>

                <Autocomplete
                    size='small'
                    id="year-select"
                    getOptionLabel={(option) => option.label.toString()}
                    options={yearArray}
                    defaultValue={initialYear}
                    onChange={(event, newValue) => { setYear(newValue.value); }}
                    getOptionSelected={(option, value) => option.value === value.value}
                    style={{ width: 200, marginTop: 20, marginLeft: 'auto', marginRight: 'auto' }}
                    blurOnSelect
                    renderInput={(params) => <TextField {...params} label="Year" variant="outlined" InputLabelProps={{ shrink: true }} />}
                />

                <div style={{color: 'red', fontStyle: 'italic', height: 30, marginTop: 10, textAlign: 'center'}}>{invalid? "Start month cannot be after end month." : ""}</div>
                
                <Container style={styles.container}>    
                    <Button onClick={onSelect} disabled={invalid} color="primary" variant="outlined">Ok</Button>
                </Container>
            </Box>
        </Popover>
    );


}